module.exports = __webpack_public_path__ + "img/fig09.8a3b4eef.jpg";